<template>
    <div id="page-steppers">
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex sm12>
                    <v-subheader>ویرایش محصول</v-subheader>
                    <v-stepper v-model="step">
                        <v-stepper-header>
                            <v-stepper-step step="1" :complete="step > 1">انتخاب فروشگاه</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step step="2" :complete="step > 2">بارگذاری طرح</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step step="3" :complete="step > 3">مدیریت محصولات</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step step="4" :complete="step > 4">تنظیمات تکمیلی</v-stepper-step>
                        </v-stepper-header>
                        <v-stepper-items>
                            <v-stepper-content step="1">
                                <v-layout wrap>
                                    <v-flex
                                            class="-mouse-pointer"
                                            :key="store.id"
                                            v-for="(store,_) in stores"
                                            md4 xs4>
                                        <v-card class="ma-2" style="text-align: center"
                                                @click="selectStore(store.shop_id)">
                                            <img :src="`/stores/` + store.picture" style="width: 250px;margin:0 auto;">
                                            <v-divider></v-divider>
                                            <v-card-actions>
                                                <v-btn flat block large class="success" small> ایجاد طرح در
                                                    {{store.shop_name}}
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-stepper-content>
                            <v-stepper-content step="2">

                                <v-layout class="align-content-center text-xs-center justify-center">
                                    <v-flex xs7>
                                        <FileSelect
                                                v-model="image"
                                                :url="`/reseller/artworks`"
                                                :form="this.form"
                                                @done="afterUpload"
                                        ></FileSelect>
                                    </v-flex>

                                </v-layout>

                                <v-layout class="text-xs-center justify-center px-2" v-if="form.base_image != ''">
                                    <v-flex xs6
                                            :style="`background: rgba(`+form.bg_color.r+`,`+form.bg_color.g+`,`+form.bg_color.b+`,`+form.bg_color.a+`);border: 1px dashed #505050;`">
                                        <img :src="`/reseller_privates/org_artworks/` +form.base_image" width="100%"/>
                                    </v-flex>
                                </v-layout>
                                <v-layout class="text-xs-center justify-center px-2">
                                    <v-flex xs6>
                                        <v-dialog v-model="bg_color_modal" persistent max-width="300px">
                                            <v-btn color="blue" class="white--text" block
                                                   slot="activator">
                                                <v-icon dark>colorize</v-icon>
                                                &nbsp;
                                                انتخاب رنگ زمینه نمایش طرح

                                            </v-btn>
                                            <v-card>
                                                <v-card-title>
                                                    <span class="headline">انتخاب رنگ</span>
                                                    <v-spacer></v-spacer>
                                                    <v-btn color="blue darken-1" flat icon=""
                                                           @click.native="bg_color_modal = false">
                                                        <v-icon>close</v-icon>
                                                    </v-btn>
                                                </v-card-title>
                                                <v-divider></v-divider>
                                                <v-card-text>
                                                    <v-container grid-list-md>
                                                        <color-picker @input="updateColorValue"
                                                                      v-model="form.bg_color"></color-picker>
                                                    </v-container>
                                                </v-card-text>
                                            </v-card>
                                        </v-dialog>
                                    </v-flex>
                                </v-layout>

                                <v-layout>
                                    <v-flex>
                                        <v-text-field
                                                label="عنوان طرح"
                                                name="name"
                                                v-model="form.title"
                                                type="text"
                                                :rules="[rules.required]"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex>
                                        <v-autocomplete
                                                label="دسته بندی"
                                                :items="artwork_categories"
                                                v-model="form.category_id"
                                                autocomplete
                                                menu-props="auto"
                                                required
                                                item-text="name"
                                                item-value="ac_id"
                                        ></v-autocomplete>
                                    </v-flex>
                                </v-layout>
                                <v-layout>

                                    <v-flex xs6>
                                        <v-combobox
                                                multiple
                                                label="کلمات کلیدی طرح(جدا کردن با Enter)"
                                                name="tags"
                                                maxlength="255"
                                                v-model="form.keywords"
                                        ></v-combobox>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                                label="توضیحات طرح"
                                                name="description"
                                                v-model="form.description"
                                                type="text"

                                        ></v-text-field>
                                    </v-flex>

                                </v-layout>
                                <v-btn flat @click.native="step = 1">برگشت</v-btn>
                                <v-btn color="primary" @click="goToFinal()">ادامه
                                    <v-icon class="white--text">keyboard_arrow_left</v-icon>
                                </v-btn>
                                <v-btn color="success" @click.native="Finalize">
                                    <v-icon>save</v-icon>
                                    &nbsp;
                                    ذخیره
                                </v-btn>
                            </v-stepper-content>
                            <v-stepper-content step="3">
                                <v-layout row wrap>
                                    <v-flex
                                            xs12
                                            md4
                                            lg4
                                            xl4
                                            sm4
                                            :key="bf.id"
                                            v-for="(bf) in blank_families"
                                            v-bind="{ [`xs4`]: true }"
                                    >
                                        <v-card height="100%">
                                            <v-img
                                                    :src="bf.icon"
                                                    height="200px"
                                            >
                                                <v-container
                                                        fill-height
                                                        fluid
                                                        pa-2
                                                >
                                                    <v-layout fill-height>
                                                        <v-flex xs12 align-end flexbox>
                                                            <span class="headline white--text"
                                                                  v-text="bf.family_name"></span>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </v-img>

                                            <v-card-actions>
                                                <!--v-if="bf.min_width_px < form.base_image_width && bf.min_height_px < form.base_image_height"-->
                                                <v-container>

                                                    <v-layout row wrap class="align-content-center text-center">
                                                        <v-flex xs12 lg5>
                                                            <v-layout row wrap>
                                                                <v-switch
                                                                        v-if="checkArtAssets(bf.id)"
                                                                        label="وضعیت فروش"
                                                                        class="pb-0 pt-0"
                                                                        @change="changedArtAssets = true"
                                                                        v-model="form.artworks_assets[bf.id].enabled"
                                                                ></v-switch>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 lg7>
                                                            <v-chip color="blue" style="text-align: center"
                                                                    class="white--text">سود:<input
                                                                    data-number
                                                                    name="amount"
                                                                    autocomplete="off"
                                                                    required
                                                                    type="text"
                                                                    @change="changedArtAssets = true"
                                                                    v-model.number="form.artworks_assets[bf.id].commission"
                                                                    style="margin:auto 5px;border:1px solid #fff;max-width:60px;text-align: center"
                                                            >%
                                                            </v-chip>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout>
                                                        <v-flex>
                                                            <v-btn
                                                                    @click="OpenModal(bf.id)"
                                                                    color="primary darken-2"
                                                                    block
                                                            >
                                                                <v-icon color="white">build</v-icon>
                                                                &nbsp;
                                                                تنظیمات طرح
                                                            </v-btn>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </v-card-actions>
                                            <!-- <v-card-actions class="text-xs-centers justify-center" v-else>
                                                 <v-alert
                                                         width="100%"
                                                         class="pt-0 pb-1"
                                                         :value="true"
                                                         type="warning"
                                                 >
                                                     حداقل عرض {{bf.min_width_px}}px و ارتفاع {{bf.min_height_px}}px لازم
                                                     است.
                                                 </v-alert>
                                             </v-card-actions>-->

                                        </v-card>
                                    </v-flex>
                                </v-layout>

                                <v-btn flat @click.native="step = 2">برگشت</v-btn>
                                <v-btn color="primary" @click="gotoSetting">ادامه
                                    <v-icon class="white--text">keyboard_arrow_left</v-icon>
                                </v-btn>
                            </v-stepper-content>
                            <v-stepper-content step="4">
                                <v-checkbox color="blue" label="قرارگیری در بازارچه‌ی طراحان چاپچی"
                                            v-model="marketplace.is_in_marketplace"></v-checkbox>
                                <div v-if="marketplace.is_in_marketplace">
                                    <v-alert :value="true" type="info" :color="mpStatusColor">وضعیت: {{mpStatusText}}
                                    </v-alert>
                                    <v-layout row>
                                        <v-flex
                                                v-bind:key="`cat_` + id"
                                                v-for="(cat,id) in getSubMpCats(0)">
                                            <v-autocomplete
                                                    :items="getSubMpCats(cat.m_cat_id)"
                                                    item-text="cat_name"
                                                    item-value="m_cat_id"
                                                    multiple
                                                    :label="cat.cat_name"
                                                    :name="cat.cat_name"
                                                    v-model="marketplace.categories"
                                            ></v-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row>
                                        <v-flex>
                                            <v-textarea label="توضیحات شما برای مدیریت جهت قرارگیری"
                                                        v-model="marketplace.user_description"
                                                        maxlength="1024"></v-textarea>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout v-if="marketplace.admin_description.length > 0" row>
                                        <v-flex>
                                            راهنمایی مدیریت در مورد قرارگیری در بازارچه:
                                            <v-alert :value="true" type="info">{{marketplace.admin_description}}
                                            </v-alert>
                                        </v-flex>
                                    </v-layout>

                                </div>

                                <v-btn flat @click.native="step = 3">برگشت</v-btn>
                                <v-btn color="success" @click.native="Finalize">
                                    <v-icon>save</v-icon>
                                    &nbsp;
                                    ذخیره
                                </v-btn>
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>
                </v-flex>
            </v-layout>
        </v-container>
        <v-snackbar
                :bottom="snackbar.y === 'bottom'"
                :color="snackbar.color"
                :left="snackbar.x === 'left'"
                :multi-line="snackbar.mode === 'multi-line'"
                :right="snackbar.x === 'right'"
                :timeout="snackbar.timeout"
                :top="snackbar.y === 'top'"
                :vertical="snackbar.mode === 'vertical'"
                v-model="snackbar.snackbar"
        >
            {{ snackbar.text }}
            <v-btn @click.native="snackbar.snackbar = false" dark flat icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>
        <v-layout row justify-center>
            <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="dialog = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>سفارشی سازی محصول</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn dark color="orange darken-4" style="font-size:16px;" @click="saveChanges">ذخیره
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>


                    <v-tabs
                            v-model="active"
                            color="primary darken-2"
                            class="text-xs-center justify-center"
                            dark
                            slider-color="yellow"
                    >
                        <v-tab
                                :key="mf.id"
                                v-for="(mf,_) in mock_frames"
                                ripple
                        >
                            <h3>{{ mf.side_name }}</h3>
                        </v-tab>
                        <v-tab-item
                                :key="mf.id"
                                v-for="(mf,_) in mock_frames"
                                @mouseover="active_mock_frame = mf.id"
                        >
                            <v-card-text>
                                <v-layout class="justify-center pb-3">

                                    <v-flex xs8 sm4>
                                        <FileSelect
                                                v-model="mock_frames_files[mf.id]"
                                                :url="`/reseller/artworks/mock_upload/`+form.art_id+`/`+mf.id"
                                                @done="LoadFrameImage"
                                        ></FileSelect>
                                    </v-flex>
                                    <v-flex xs1 sm1>
                                        <v-tooltip top>
                                            <v-btn slot="activator" flat icon large color="pink"
                                                   @click="deleteLayer(mf.id)">
                                                <v-icon large>cancel</v-icon>
                                            </v-btn>
                                            <span>حذف تصویر فعلی</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                            <v-btn slot="activator" flat icon large color="blue"
                                                   @click="undoPicture(mf.id)">
                                                <v-icon large>undo</v-icon>
                                            </v-btn>
                                            <span>استفاده از تصویر پیشفرض</span>
                                        </v-tooltip>
                                    </v-flex>
                                </v-layout>
                                <v-divider class="pb-4"></v-divider>
                                <v-layout class="justify-center">
                                    <div class="row">
                                        <div class="drag-container"
                                             :style="`background:url(/system/mock_frames/`+ mf.id + `.png);width:` + mf.frame_width +`px;height:`+ mf.frame_height +`px`">
                                            <img v-if="mf.have_cover == 1" class="cover-image"
                                                 :src="`/system/mock_frames/cover_`+ mf.id + `.png`" alt="cover">
                                            <div :class="`zone-area obj-` + mf.zone_type"
                                                 :style="`height:`+ (mf.zone_type === 'Rect'? mf.zone_height:mf.zone_width*2) + `px;width:` + (mf.zone_type === 'Rect'? mf.zone_width:mf.zone_width*2) + `px` + `;left:` + (mf.zone_type === 'Rect'? mf.zone_x:(mf.zone_x-mf.zone_width)) + `px`+ `;top:` + (mf.zone_type === 'Rect'? mf.zone_y:(mf.zone_y-mf.zone_width)) + `px`"></div>
                                            <VueDragResize
                                                    v-if="haveAsset(mf.id) > -1"
                                                    :aspectRatio="aspect_ratio"
                                                    :isActive="true"
                                                    :enable-native-drag="true"
                                                    :w="artworks_assets_frames[haveAsset(mf.id)].image_width"
                                                    :h="artworks_assets_frames[haveAsset(mf.id)].image_height"
                                                    :x="artworks_assets_frames[haveAsset(mf.id)].image_x"
                                                    :y="artworks_assets_frames[haveAsset(mf.id)].image_y"
                                                    v-on:resizing="resize"
                                                    v-on:dragging="resize"
                                            >
                                                <img :src="`/reseller_privates/org_artworks/` +getAsset(mf.id).image_file"
                                                     width="100%" height="100%">
                                            </VueDragResize>
                                        </div>
                                    </div>
                                </v-layout>

                                <v-divider class="mt-5 pb-2"></v-divider>
                                <v-layout v-if="mf.help.length > 6" class="justify-center">
                                    <v-flex xs6>
                                        <v-btn color="blue" @click="openFrameHelper(mf.help)" class="white--text" block>
                                            <v-icon>help_outline</v-icon> &nbsp;
                                            راهنمای طراحی
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                                <v-divider class="mt-2 pb-2" v-if="mf.help.length > 6"></v-divider>
                            </v-card-text>
                        </v-tab-item>
                    </v-tabs>
                    <v-divider></v-divider>
                    <v-list v-if="activeFamilies.length > 0" three-line subheader>
                        <v-subheader> رنگ‌های فعال برای خانواده‌ی محصول</v-subheader>
                        <CircleColor
                                :key="bc.cf_id"
                                v-for="(bc,_) in activeFamilies"
                                v-model="artworks_assets_color_families"
                                :bc="bc"
                                :family_id="family_id"
                                :artwork_id="form.art_id"
                                @ColorChange="changeColor"
                                style="display: inline-block"
                        ></CircleColor>
                    </v-list>
                    <v-divider></v-divider>
                    <v-list style="background: #f1f1f1" three-line subheader>
                        <v-subheader> محصولات مرتبط</v-subheader>
                        <v-layout>
                            <v-checkbox
                                    :key="`bb_` + blank.blanks_id"
                                    v-for="(blank,bk) in blanks"
                                    :label="blank.name"
                                    v-model="blanks[bk].is_checked"
                            ></v-checkbox>
                        </v-layout>

                    </v-list>

                </v-card>
            </v-dialog>
        </v-layout>
        <v-dialog v-model="helperDialog" lazy @click="helperDialog=false" persistent max-width="70%">
            <v-card>
                <v-card-title>
                    <span class="headline">راهنمای طراحی</span>
                    <v-spacer></v-spacer>
                    <v-btn icon color="red" @click="helperDialog=false">
                        <v-icon class="white--text">close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-container grid-list-md v-html="helperText">
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import HttpErrorToSnackbar from '@/api/HttpErrorToSnackbar';
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import Layout from '../../components/media/Layout';
import FileSelect from '../../components/FileSelect';
import CircleColor from '../../components/widgets/color/CircleColor';
import VueDragResize from 'vue-drag-resize';
import { Sketch } from 'vue-color';

export default {
  components: {
    Layout,
    VWidget: VWidget,
    FileSelect: FileSelect,
    CircleColor: CircleColor,
    ColorPicker: Sketch,
    VueDragResize: VueDragResize,
    datePicker: VuePersianDatetimePicker
  },
  data () {
    return {
      rand: '?333',
      changedArtAssets: false,
      loaded_marketplace: false,
      helperDialog: false,
      helperText: '',
      mock_frames_files: [],
      pre_loaded: false,
      hasImage: false,
      aspect_ratio: false,
      active_mock_frame: 0,
      image: null,
      active: null,
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
      marketplace: {
        is_in_marketplace: false,
        artwork_id: 0,
        status: null,
        user_description: '',
        admin_description: '',
        categories: []
      },
      marketplaceCategories: [],
      form: {
        title: '',
        keywords: [],
        base_image: '',
        description: '',
        art_id: 0,
        store_id: 0,
        category_id: 0,
        base_image_width: 0,
        base_image_height: 0,
        artworks_assets: [],
        finalized: false,
        bg_color: {
          r: 255,
          g: 255,
          b: 255,
          a: 1
        },
      },
      rules: {
        required: (value) => !!value || 'پر کردن این فیلد اجباری است.',
      },
      bg_color_modal: false,
      saved: false,
      formData: {},
      active_colors: [],
      blanks: [],
      artworks: [],
      artworks_blanks: [],
      mock_frames: [],
      blank_families: [],
      blanks_color_families: [],
      blanks_frame_colors: [],
      artwork_categories: [],
      artworks_assets_frames: [],
      artworks_assets_color_families: [],
      changed_frames: {},
      stores: [],
      family_id: 0,
      design_step: 1,
      step: 1,
      e13: 1,
    };
  },
  computed: {
    activeFamilies () {
      return this.blanks_color_families.filter((cf) => this.active_colors.includes(cf.cf_id));
    },
    mpStatusText () {
      let out = 'ثبت نشده';
      switch (this.marketplace.status) {
        case 'Accepted':
          out = 'تایید شده';
          break;
        case 'ModificationNeeded':
          out = 'نیاز به بازبینی طراح دارد';
          break;
        case 'Banned':
          out = 'مسدود شده';
          break;
        case 'OnHold':
          out = 'در حال بررسی توسط مدیریت';
          break;
        default:
          out = 'ثبت نشده';
      }
      return out;
    },
    mpStatusColor () {
      let out = 'purple';
      switch (this.marketplace.status) {
        case 'Accepted':
          out = 'success';
          break;
        case 'ModificationNeeded':
          out = 'orange';
          break;
        case 'Banned':
          out = 'red';
          break;
        case 'OnHold':
          out = 'info';
          break;
        default:
          out = 'purple';
      }
      return out;
    }
  },
  watch: {},
  mounted: function () {
    this.rand = '?' + Math.random();
    this.axios.get('/reseller/stores/')
      .then(response => {
        if (response.data.Data.length === 0) {
          this.snackbar.snackbar = true;
          this.snackbar.color = 'red';
          this.snackbar.text = 'ابتدا باید یک فروشگاه بسازید';
          setTimeout(() => {
            this.$router.push('/pages/store/add/');
          }, 2000);
        } else if (response.data.Data.length === 1) {
          this.selectStore(response.data.Data[0].shop_id);
        }
        this.stores = response.data.Data;
      })
      .catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });

    // Load blank families
    this.axios.get('/reseller/blank_families/?is_for_designer=0')
      .then(response => {
        this.blank_families = response.data.Data;
      })
      .catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });

    // Load blank color families
    this.axios.get('/reseller/blanks_color_families/')
      .then(response => {
        this.blanks_color_families = response.data.Data;
      })
      .catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });

    this.axios.get('/reseller/artworks/?art_id=' + this.$route.params.id)
      .then(response => {
        if (response.data.Data.length === 0) {
          this.snackbar.snackbar = true;
          this.snackbar.color = 'red';
          this.snackbar.text = 'موردی یافت نشد!';
          return;
        }
        response.data.Data[0].keywords = response.data.Data[0].keywords.split(',');
        let bg = response.data.Data[0].bg_color.split(',');
        response.data.Data[0].bg_color = {
          r: bg[0],
          g: bg[1],
          b: bg[2],
          a: bg[3],
        };
        Object.assign(this.form, response.data.Data[0]);
        this.form.finalized = false;
        this.selectStore(this.form.store_id);
        this.loadLayerAssets();

      })
      .catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });
  },
  methods: {
    openFrameHelper: function (text) {
      this.helperDialog = true;
      this.helperText = text;
    },
    checkArtAssets: function (bf_id) {
      if (typeof this.form.artworks_assets[bf_id] === 'undefined') {
        this.form.artworks_assets[bf_id] = {
          commission: this.blank_families.find(bf => bf.id === bf_id).default_commission,
          family_id: bf_id,
          enabled: true
        };
      }
      return true;
    },
    saveChanges: function () {
      this.dialog = false;
      let data = {
        blanks: this.blanks,
        frames: this.changed_frames,
        colors: this.artworks_assets_color_families
      };
      this.axios.post('/reseller/artworks_save_data/' + this.family_id + '/' + this.form.art_id, data)
        .then(response => {
          this.snackbar.text = 'با موفقیت ذخیره شد.';
          this.snackbar.color = 'green';
          this.snackbar.snackbar = true;
          this.loadLayerAssets();
        })
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
        });
    },
    LoadFrameImage () {
      // this.OpenModal(this.family_id);
      this.aspect_ratio = false;
      this.loadLayerAssets();
    },
    next () {
      const active = parseInt(this.active, 10);
      this.active = (active < 2 ? active + 1 : 0);
    },
    haveAsset (id) {
      return this.artworks_assets_frames.findIndex(aaf => aaf.frame_id === id);
    },
    changeColor (data) {
      this.artworks_assets_color_families = data;
    },
    getAsset (id) {
      id = this.artworks_assets_frames.findIndex(aaf => aaf.frame_id === id);
      if (id > -1) {
        return this.artworks_assets_frames[id];
      }
      return null;
    },
    resize (newRect) {
      if (typeof this.changed_frames['f_' + this.active_mock_frame] === 'undefined') {
        this.changed_frames['f_' + this.active_mock_frame] = {};
      }
      this.changed_frames['f_' + this.active_mock_frame] = newRect;
    },
    OpenModal: function (family_id) {
      this.dialog = true;
      this.mock_frames = [];
      this.mock_frames_files = [];
      this.family_id = family_id;

      this.axios.get('/reseller/mock_frames/?order_by=default_enabled&family_id=' + family_id)
        .then(response => {
          if (response.data.Data.length === 0) {
            this.snackbar.text = 'هیچ موردی برای این خانواده‌ی طرح یافت نشد.';
            this.snackbar.color = 'red';
            this.snackbar.snackbar = true;
            return;
          }
          response.data.Data.forEach((mf) => {
            this.mock_frames_files[mf.id] = null;
          });
          for (let i = 0; i < response.data.Data.length; i += 1) {
            response.data.Data[i].blanks = response.data.Data[i].blanks.split(',').map(b => {
              b = Number(b);
              return b;
            });
          }
          this.mock_frames = response.data.Data;
        })
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
        });

      // Load artwork blanks
      this.axios.get('/reseller/artworks_blanks/?artwork_id=' + this.form.art_id)
        .then(response => {
          this.artworks_blanks = response.data.Data;
          // Load blanks
          this.axios.get('/reseller/blanks/?family_id=' + family_id)
            .then(response => {
              this.blanks = response.data.Data;
              this.blanks.forEach((v, k) => {
                this.blanks[k].blank_id = v.blanks_id;
                // eslint-disable-next-line max-nested-callbacks
                if (this.artworks_blanks.findIndex(ab => ab.blanks_id === v.blanks_id) > -1) {
                  this.blanks[k].is_checked = true;
                } else {
                  this.blanks[k].is_checked = false;
                }
              });
            })
            .catch(error => {
              this.snackbar = HttpErrorToSnackbar(error);
            });
        })
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
        });

      this.axios.get('/reseller/blank_families_colors_relation/' + family_id)
        .then(response => {
          this.active_colors = response.data.data === null ? [] : response.data.data;
        }).catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
        });

      this.axios.get('/reseller/artworks_assets_color_families/?artwork_id=' + this.form.art_id + '=&family_id=' + family_id)
        .then(response => {
          this.artworks_assets_color_families = response.data.Data;
        })
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
        });
    },
    deleteLayer: function (mfID) {
      this.axios.delete('/reseller/artworks_assets_frames/' + this.form.art_id + '/' + mfID)
        .then(() => {
          this.snackbar.text = 'با موفقیت حذف شد!';
          this.snackbar.color = 'green';
          this.snackbar.snackbar = true;
          this.artworks_assets_frames = this.artworks_assets_frames.filter(aaf => aaf.frame_id !== mfID);
        }).catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
        });
    },
    undoPicture: function (mfID) {
      this.axios.put('/reseller/artworks_assets_frames/' + this.form.art_id + '/' + mfID)
        .then(() => {
          this.snackbar.text = 'با موفقیت جایگزین شد!';
          this.snackbar.color = 'green';
          this.snackbar.snackbar = true;
          this.loadLayerAssets();
        }).catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
        });
    },
    selectStore: function (id) {
      this.form.store_id = id;
      this.loadCategory(id);
      this.step = 2;

    },
    loadCategory: function (id) {
      this.axios.get('/reseller/artwork_categories/?store_id=' + id)
        .then(response => {
          if (response.data.CountAll === 0) {
            this.snackbar.snackbar = true;
            this.snackbar.color = 'red';
            this.step = 1;
            this.snackbar.text = 'ابتدا برای این فروشگاه یک دسته بندی بسازید';
          }
          this.artwork_categories = response.data.Data;
        })
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
        });

    },
    afterUpload: function (response) {
      this.rand = '?' + Math.random();
      this.form.art_id = response.art_id;
      this.form.base_image = response.base_image;
      this.form.base_image_height = response.base_image_height;
      this.form.base_image_width = response.base_image_width;
      this.snackbar.text = 'با موفقیت انجام شد.';
      this.snackbar.y = 'bottom';
      this.snackbar.color = 'success';
      this.snackbar.snackbar = true;
      this.loading = false;
      this.loadLayerAssets();
    },
    loadAssetFrames () {
      this.axios.get('/reseller/artworks_assets_frames/?artwork_id=' + this.form.art_id)
        .then(response => {
          this.aspect_ratio = false;
          this.artworks_assets_frames = response.data.Data;
          setTimeout(() => {
            this.aspect_ratio = true;
          }, 300);
        })
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
        });
    },
    loadLayerAssets () {
      this.loadAssetFrames();

      // Load artwork assets -- > families
      if (!this.changedArtAssets) {
        this.axios.get('/reseller/artworks_assets/?artwork_id=' + this.form.art_id)
          .then(response => {
            response.data.Data.forEach((v, k) => {
              if (typeof this.form.artworks_assets[v.family_id] !== 'undefined') {
                this.form.artworks_assets[v.family_id] = {
                  commission: v.commission,
                  family_id: v.family_id,
                  enabled: v.enabled
                };
              }
            });
            this.changedArtAssets = true;
          })
          .catch(error => {
            this.snackbar = HttpErrorToSnackbar(error);
          });
      }
      //
      this.axios.get('/reseller/artworks_assets_color_families/?artwork_id=' + this.form.art_id)
        .then(response => {
          this.artworks_assets_color_families = response.data.Data;
        })
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
        });
    },
    updateColorValue (e) {
      this.form.bg_color = e.rgba;
    },
    getSubMpCats (parent_id) {
      return this.marketplaceCategories.filter(mp => mp.parent_id === parent_id);
    },
    gotoSetting () {
      if (this.loaded_marketplace) {
        this.step = 4;
        return;
      }
      // get Categories Data
      this.axios.get('/reseller/marketplace_categories/')
        .then(response => {
          this.marketplaceCategories = response.data.Data;
          this.step = 4;
        }).catch(err => {
          this.snackbar = HttpErrorToSnackbar(err);
        });

      this.axios.get('/reseller/marketplace_item_cats/' + this.form.art_id)
        .then(response => {
          this.marketplace.categories = response.data.data;
          this.axios.get('/reseller/marketplace_item/?artwork_id=' + this.form.art_id)
            .then(response => {
              if (response.data.data.length === 0) {
                this.marketplace.is_in_marketplace = false;
              } else {
                this.marketplace.is_in_marketplace = true;
                this.marketplace.user_description = response.data.data[0].user_description;
                this.marketplace.admin_description = response.data.data[0].admin_description;
                this.marketplace.status = response.data.data[0].status;
                this.marketplace.artwork_id = response.data.data[0].artwork_id;
              }
              this.step = 4;
              this.loaded_marketplace = true;
            }).catch(err => {
              this.snackbar = HttpErrorToSnackbar(err);
            });
        }).catch(err => {
          this.snackbar = HttpErrorToSnackbar(err);
        });
    },
    goToFinal () {
      if (this.form.art_id === 0) {
        this.snackbar.text = 'ابتدا فایل طرح میبایست بارگذاری شود.';
        this.snackbar.color = 'red';
        this.snackbar.snackbar = true;
        return;
      }
      this.step = 3;
    },
    changeProducts (bk, e) {
      let id = this.blanks.findIndex(b => b.blanks_id === bk);
      if (id < 0) {
        return;
      }
      this.blanks[id].is_checked = e !== null;
    },
    Finalize () {
      let data = Object.assign({}, this.form);
      data.keywords = data.keywords.join(',');
      data.bg_color = data.bg_color.r + ',' + data.bg_color.g + ',' + data.bg_color.b + ',' + data.bg_color.a;
      data.artworks_assets = data.artworks_assets.filter(a => a !== null);
      data.finalized = true;
      this.axios.put('/reseller/artworks/' + this.form.art_id, data)
        .then(response => {
          // Response Submit Method
          this.snackbar.text = 'با موفقیت ذخیره شد!';
          this.snackbar.y = 'bottom';
          this.snackbar.color = 'success';
          this.snackbar.snackbar = true;
          this.loading = false;
          this.saved = true;
        })
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
          this.loading = false;
        });
      // Save Marketplace
      this.axios.post('/reseller/marketplace_item/' + this.form.art_id, this.marketplace)
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
          this.loading = false;
        });
    }
  }
};
</script>
<style>
    .-mouse-pointer {
        cursor: pointer;
    }

    .drag-container {
        position: relative;
        border: 1px dashed #7f7f7f;
    }

    .zone-area {
        position: absolute;
        background-color: rgba(0, 0, 0, 0.12);
        -webkit-transition: ease-out 440ms;
        -moz-transition: ease-out 440ms;
        -ms-transition: ease-out 440ms;
        -o-transition: ease-out 440ms;
        transition: ease-out 440ms;
        z-index: 9;

        animation-duration: 444ms;
        animation-name: blink;
        animation-iteration-count: infinite;
        animation-direction: alternate;
        -webkit-animation: blink 444ms infinite; /* Safari and Chrome */
    }

    .drag-container:hover .zone-area,
    .drag-container:hover .cover-image {
        z-index: auto;
    }

    .cover-image {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        z-index: 999;
    }

    .obj-Circle {
        border-radius: 100%;
    }

    .vdr-stic {
        z-index: 99;
    }

    .text-shadow {
        text-shadow: 1px 1px 2px #ffffff;
    }

    .selected-color {
        -webkit-box-shadow: 0 0 14px #f00000 !important;
        -moz-box-shadow: 0 0 14px #f00000 !important;
        box-shadow: 0 0 14px #f00000 !important;
    }

    @keyframes blink {
        from {
            border: 1px dashed red;
        }
        to {
            border: 0;
        }
    }

    @-webkit-keyframes blink {
        from {
            border: 1px dashed red;
        }
        to {
            border: 0;
        }
    }

</style>



// WEBPACK FOOTER //
// src/pages/art/edit.vue